import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// === 전역 axios 인터셉터 (세션 만료 통합 처리) ===
import './utils/axios-setup.js'

// === Scripts 전역 Import ===
// 인증 관련
import './assets/scripts/auth-check.js'
import './assets/scripts/auth-header.js'  // 헤더 인증 버튼 동적 관리
import './assets/scripts/auth-signup.js'
import './assets/scripts/auth-change-password.js'
import './assets/scripts/auth-edit-profile.js'
import './assets/scripts/logout.js'

// 메뉴 및 네비게이션
import './assets/scripts/menu.js'
import './assets/scripts/nav.js'

// 대출 관련
import './assets/scripts/loan_form.js'
import './assets/scripts/loan-transaction.js'
import './assets/scripts/loan-repayment.js'
import './assets/scripts/contract.js'
import './assets/scripts/contract_form.js'

// 전자서명
import './assets/scripts/signature.js'

// 약관 관련
import './assets/scripts/terms.js'
import './assets/scripts/terms_content.js'

// 비밀번호 찾기
import './assets/scripts/find-id.js'
import './assets/scripts/find-password.js'
import './assets/scripts/reset-password.js'

// 기타 유틸리티
import './assets/scripts/slider.js'
import './assets/scripts/include.js'
import './assets/scripts/include-advanced.js'
import './assets/scripts/template-include.js'
import './assets/scripts/iframe-resize.js'
import './assets/scripts/main.js'

const app = createApp(App)

app.use(router).mount('#app')

// auth-header.js 등 순수 JS 파일에서 router 사용 가능하도록 전역 노출
window.vueRouter = router
